// Set when building the frontend image; production and staging use different images.
export const notificationsEnabled = process.env.REACT_APP_NOTIFICATIONS_ENABLED !== 'false';
